import { Group, Tooltip } from '@mantine/core'
import { useClipboard } from '@mantine/hooks'
import React from 'react'

type TCopyClipboardTrigger = {
  /**
   * Copy to clipboard button
   */
  children?: React.ReactNode

  /**
   * Description of the data (barcode, name, etc.)
   */
  label?: string

  /**
   * Content to copy to clipboard
   */
  content: string
  lg?: boolean
  fontSize?: string
  withCopyIcon?: boolean
}

const CopyClipboardTrigger = (
  props: TCopyClipboardTrigger,
): React.ReactElement => {
  const { children, label, content, lg = false, fontSize, withCopyIcon } = props

  const copyIcon = (
    <span>
      <i
        style={{ fontSize: fontSize ? fontSize : lg ? '1.8em' : '0.85em' }}
        className="far fa-copy"
      />
    </span>
  )

  const clipboard = useClipboard()
  const inner =
    (withCopyIcon ? (
      <Group spacing={5} noWrap>
        {children}
        {copyIcon}
      </Group>
    ) : (
      children
    )) || copyIcon

  return (
    <Tooltip
      label={
        clipboard.copied
          ? i18n.t(`copied_var_clipboard`, {
              defaultValue: `{{placeholder1}} in Zwischenablage kopiert!`,
              placeholder1: label,
            })
          : i18n.t(`copy_x`, {
              defaultValue: `{{placeholder1}} kopieren`,
              placeholder1: label,
            })
      }
    >
      {React.cloneElement(inner as React.ReactElement, {
        onClick: () => clipboard.copy(content),
        style: { cursor: 'pointer' },
      })}
    </Tooltip>
  )
}
export default CopyClipboardTrigger
